import $ from 'jquery';
$(function () {
    const $relatedArticles = $('.js-article-content .js-article-preview');

    if ($relatedArticles.length > 0) {
        const $firstRelatedArticle = $relatedArticles.first();
        const $lastRelatedArticle = $relatedArticles.last();

        $firstRelatedArticle.addClass('article--preview--first');
        $lastRelatedArticle.addClass('article--preview--last');
    }
});
